import GenetecVideoPlayer from './GenetecVideoPlayer';

export default GenetecVideoPlayer;
export * from './types';
export { GenetecVideoPlayer };
